import { useQuery } from "@tanstack/react-query";
import { EventLogsService } from "../services/eventlogs.service";

export function useGetEventLogs(participantId: string, enrollmentId: string) {
  return useQuery({
    queryKey: ["event-logs", participantId, enrollmentId],
    queryFn: () => {
      if (!participantId || !enrollmentId) {
        return Promise.resolve([]);
      }
      return EventLogsService.findByParticipant(participantId, enrollmentId);
    },
    enabled: Boolean(participantId),
  });
}
